import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLanguage } from "@/lib/LanguageContext";

export function useCheckout() {
  const [isProcessing, setIsProcessing] = useState(false);
  const { t, lang } = useLanguage();

  const handleCheckout = async (tier, fileId, countryCode, adFormat) => {
    if (!fileId) {
      toast.error(t("toast.uploadFirst"));
      return;
    }

    setIsProcessing(true);

    try {
      const response = await api.post("/checkout", {
        file_id: fileId,
        country_code: countryCode,
        ad_format: adFormat,
        origin_url: window.location.origin,
        tier: tier,
        lang: lang,
      });

      window.location.href = response.data.checkout_url;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || t("toast.checkoutFailed");
      toast.error(errorMessage);
      setIsProcessing(false);
    }
  };

  return {
    isProcessing,
    handleCheckout,
  };
}
